export default __webpack_public_path__ + "static/SkyAcademy-min-deddc936399c4e05d5df418a20d12e35.pdf";